import { render, staticRenderFns } from "./ChatKwai.vue?vue&type=template&id=491cc93a&"
import script from "./ChatKwai.vue?vue&type=script&lang=js&"
export * from "./ChatKwai.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports